<template>
  <n-modal class="modal-add-access" :loading="$var('load')" @close="$emit('close')">
    <h3>Добавить полномочия</h3>
    <n-form @submit="submit">
      <n-items>
        <n-select title="От лица компании" :data="companies" v-bind="$form.input('company', 'select')" />
        <n-select title="Полномочие" :data="types" v-bind="$form.input('type', 'select')" item-value="name" option-title="description" selected-title="description" />
        <!--        <n-select title="Элемент структуры" :data="structure" :value.sync="selectedStructure" item-value="id" option-title="title"-->
        <!--                  selected-title="title" />-->
        <!--        <n-select title="Вид работ" :data="workTypes" :value.sync="selectedWorkTypes" item-value="id"-->
        <!--                  option-title="title" selected-title="title" />-->
        <n-button color="primary" wide type="submit">Назначить</n-button>
      </n-items>
    </n-form>
  </n-modal>
</template>

<script>
export default {
  name: 'ModalAddAccess',
  props: [ 'project', 'company', ],
  data: () => ({
    types: [],
    companies: [],
  }),
  created() {
    this.$form.init({
      company: null,
      type: null,
    })
    this.loadData()
  },
  methods: {
    loadData() {
      this.$var('load', true)
      const api = [
        $api.iq.accesses.partners.partnerTree(this.project.id),
        $api.my.companies().filter({ project: this.project.id, }),
      ]
      Promise.all(api).then((result) => {
        const types = []
        $n.each(result[0].data.content, (i, e) => {
          types.push({ name: e, description: i, })
        })
        this.types = types
        this.companies = result[1].data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    submit() {
      this.$var('load', true)
      const data = {
        type: this.$form.get('type.name'),
        companyId: this.$form.get('company.id'),
      }
      $api.iq.accesses.partners.create(this.project.id, this.company.id, data).then((response) => {
        this.$emit('close')
        this.$emit('submit')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .modal-add-access {
  
  }
</style>
